import styled from "styled-components";

export const Container = styled.div `

    display: flex;
    flex-direction: column;

    .section-biográfia-pessoa {
        margin-top: 30px;
    }

    .section-biográfia-pessoa h2 {
        text-transform: uppercase;
        font-size: 20px;
        margin-bottom: 10px;
    }

    .icon-margin-right {
        margin-right: 5px;
    }

    .section-biográfia-pessoa span {
        color: #ccc;
        font-size: 15px;
    }

    .redes-sociais-pessoa-sobre {
        display: flex;
    }
    
    .redes-sociais-pessoa-sobre a {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 1.2rem;
        margin: 3px 0;
        transition: all .3s ease;
    }
    
    .redes-sociais-pessoa-sobre a:hover {
        transform: scale(1.3);
    }

    .redes-sociais-pessoa-sobre a {
        margin-right: 15px;
        height: 25px;
    }



`